<div class="contributors-container" (cdkDropListDropped)="drop($event)" cdkDropList>
  <okr-contributor-item
    class="gh-siv-section-item contributor"
    *ngFor="let item of goalChildren"
    [attr.data-test-id]="'objective-modal-kr-container-' + getAriaLabel(item)"
    [item]="item"
    [goal]="goal"
    [goalChildren]="goalChildren"
    [planningSession]="planningSession"
    [allowedActions]="allowedActions"
    [isTrialAccount]="isTrialAccount"
    [coloringStrategy]="coloringStrategy"
    [assigneesIdMap]="assigneesIdMap"
    [isAllowedToSubmitToMarketplace]="isAllowedToSubmitToMarketplace"
    [methodologySettings]="methodologySettings"
    (addChildObjective)="onAddObjectiveClick($event)"
    (openMoveMetricModal)="onOpenMoveMetricModal($event)"
    (openCloneMetricModal)="onOpenCloneMetricModal($event)"
    (openDisableSyncModal)="onOpenDisableSyncModal($event)"
    (confirmDeleteMetric)="onConfirmDeleteMetric($event)"
    (handleOpenCascadingForm)="onHandleOpenCascadingForm($event)"
    (openUpdateMetricModal)="onOpenUpdateMetricModal($event)"
    (copyItemUrlToClipboard)="onCopyItemUrlToClipboard($event)"
    cdkDrag>
  </okr-contributor-item>
</div>
